import styled from 'styled-components'

import { helpers } from 'styles'

export const Title = styled.h1`
	margin: 0;
	padding: 54px 12px 48px;
	max-width: 1200px;
	width: 100%;
	color: ${helpers.color.textContrast};
	z-index: 1;
`
